var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{ref:"element",attrs:{"cols":"12","lg":"8"}},[_c('div',{staticClass:"post-content text-justify",domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }